import styled, { ThemedStyledProps } from 'styled-components';
import { transparentize } from 'polished';
import { device } from '../breakpoints';

export const shadowBorderString = (props: ThemedStyledProps<any, any>) => {
    return props.theme.borderColor
        ? `
border: 0.1rem solid ${props.theme.borderColor};
`
        : `
box-shadow: 0 0.1em 0.1em 0 ${transparentize(0.3, props.theme.secondColorDarker)}, 0 0.1em 0.3em 0.1em ${transparentize(
              0.5,
              props.theme.secondColorDarker
          )} ;

`;
};

export const ShadowOrBorderBox = styled.div`
    ${(props) => shadowBorderString(props)}
`;

export const Background = styled.div((props) => ({
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: props.theme.backgroundColor ? props.theme.backgroundColor : 'transparent',
}));

export const ContaineDiv = styled.div<{ cols: number; rows: number }>`
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    font-size: 1vw;
    /*font-size: min(${(p) => (p.rows / p.cols) * 2}vw, ${(p) => (p.cols / p.rows) * 2}vh);*/
`;

export const CarouselDiv = styled.div<{ cols: number; rows: number }>`
    position: relative;
    overflow: scroll;
    width: 86%;
    height: 86%;
    max-width: ${(p) => (p.cols / p.rows) * 86}vh;
    max-height: ${(p) => (p.rows / p.cols) * 86}vw;

    display: flex;
    flex-direction: row;
    justify-content: center;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
        display: none;
    }
`;
export const CarouselPageDiv = styled.div<{ page: number }>`
    position: absolute;
    width: 100%;
    height: 100%;
    left: ${(props) => props.page * 100}%;
    // display: flex;
    // flex-direction: row;
    // justify-content: center;
`;

export const CarouselRowDiv = styled.div<{ rows: number }>`
    display: flex;
    // flex-direction: column;
    // justify-content: center;

    width: 100%;
    height: ${(props) => 100 / props.rows}%;
`;

export const ArrowButton = styled.div`
    width: 1rem;
    padding: 1rem;
`;

export const ArrowIcon = styled(ShadowOrBorderBox)<{ disabled: boolean }>`
    position: absolute;
    top: calc(50% - 3vh);

    @media ${device.mobileL} {
        top: calc(50% - 1.5vh);
    }
    @media ${device.laptop} {
        top: calc(50% - 2vh);
    }

    border-radius: 50%;
    background: ${(props) => props.theme.secondColor};
    color: ${(props) => props.theme.mainColor};
    z-index: 10;
    cursor: pointer;
    transition: opacity 0.25s ease 0s;
    width: 4vw;
    height: 4vw;
    @media only screen and (${device.laptop}) {
        width: 6vw;
        height: 6vw;
    }
    padding: 0rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 3.5em;
    opacity: ${(props) => (props.disabled ? 0 : 1)};
    @media ${device.laptop} {
        width: 4vw;
        height: 4vw;
    }
    @media ${device.mobileL} {
        width: 6vw;
        height: 6vw;
    }
`;

export const ItemContainer = styled.div<{ cols: number }>`
    position: relative;
    width: calc(100% / ${(props) => props?.cols});
    //font-family: 'Nunito', serif;
    &:after {
        content: '';
        display: block;
        padding-bottom: 100%;
    }
`;

export const ItemDiv = styled(ShadowOrBorderBox)<{ gap: number }>`
    position: absolute;

    background: ${(props) => props.theme.secondColor};
    //box-sizing: border-box;
    border-radius: 10%;

    margin: ${(props) => props.gap / 2}%;
    width: ${(props) => 100 - props.gap}%;

    height: ${(props) => 100 - props.gap}%;
    // width: 12vw;
    // height: 15vw;
    // @media ${device.laptop} {
    //   width: 15vw;
    //   height: 16vw;
    // }
    // @media ${device.mobileL} {
    //   width: 16vw;
    //   height: 17vw;
    // }
`;

export const ItemLogo = styled.img`
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: absolute;
`;

export const ItemLogoDiv = styled.div`
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: absolute;
    color: ${(props) => props.theme.mainColor};

    > .svg-inline--fa {
        object-fit: contain;
        height: 100%;
        width: 100%;
    }
`;

export const CarouselIconDiv = styled.div`
    left: 8%;
    top: 8%;
    width: 28%;
    height: 28%;
    position: absolute;
`;

export const ItemMain = styled.div`
    position: absolute;
    height: 20%;
    margin: 10%;
    top: 45%;
    width: 80%;
    overflow-wrap: break-word;

    //font-family: 'Nunito', sans-serif;
    font-weight: 700;
    font-size: 1.7em;
    color: ${(props) => props.theme.mainColor};
    //word-break: break-all;
    line-height: 1;

    @media ${device.mobileL} {
    }
`;

export const NumberOfActiveDocs = styled.div((props) => ({
    position: 'absolute',
    borderRadius: '1em',
    top: '0.3em',
    right: '0.3em',
    padding: '0.7em',
    minWidth: '1em',
    height: '0.3em',
    fontSize: '1.5em',
    textAlign: 'center',
    color: props.theme.borderColor ? props.theme.mainColor : props.theme.secondColor,
    border: props.theme.borderColor ? `0.1rem solid ${props.theme.borderColor}` : 'none',
    backgroundColor: props.theme.borderColor ? props.theme.secondColor : props.theme.mainColor,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
}));

export const ArrowIconDiv = styled.div`
    width: 10%;
    height: 10%;
    bottom: 8%;
    right: 8%;
    position: absolute;
    font-size: 2em;
    color: ${(props) => props.theme.mainColor};
`;

export const NavList = styled.nav`
    position: absolute;
    left: 0;
    width: 98%;
    bottom: 2.8rem;
    height: 2rem;
    //margin-top:-10px;
    text-align: center;
    @media ${device.mobileL} {
        width: 95%;
        bottom: 1.8rem;
    }
    @media ${device.laptopL} {
        width: 95%;
        bottom: 1.8rem;
    }

    > ul {
        display: inline-block;
        text-align: center;
        position: relative;
    }
`;

export const NavDot = styled.li<{ active: boolean }>`
    display: inline-block;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    margin: 0 5rem;
    @media ${device.laptopL} {
        width: 1.8rem;
        height: 1.8rem;
        margin: 0 3rem;
    }

    @media ${device.mobileL} {
        width: 1.2rem;
        height: 1.2rem;
        margin: 0 1.5rem;
    }
    box-sizing: border-box;
    background-color: ${(props) => props.theme.mainColor};
    opacity: ${(props) => (props.active ? 1 : 0.6)};
    cursor: pointer;
`;

export const ListViewButton = styled.button`
    position: absolute;
    top: 2%;
    left: 9%;
    background: ${(props) => props.theme.secondColor};
    color: ${(props) => props.theme.mainColor};
    font-style: italic;
    font-size: 2.5em;
    border: none;
    border-radius: 0.3em;
    padding: 0.4rem 0.9em;
    margin: 0 0 1em 0;
    ${(props) => shadowBorderString(props)}

    @media ${device.laptopL} {
        font-size: 1.5rem;
    }

    @media ${device.mobileL} {
        font-size: 0.6rem;
    }
`;

export const ListViewContrastButton = styled.button`
    position: absolute;
    top: 2%;
    left: 74%;
    z-index: 1;
    background: ${(props) => props.theme.secondColor};
    color: ${(props) => props.theme.mainColor};
    font-weight: 600;
    font-style: italic;
    font-size: 1.6em;
    border: none;
    border-radius: 0.3em;
    margin: 0 0 1em 0;
    ${(props) => shadowBorderString(props)}
    background: ${(props) => props.theme.secondColor};
    color: ${(props) => props.theme.mainColor};
    padding: 0.4rem 0.9em;

    @media ${device.laptopL} {
        font-size: 1.5rem;
    }
    @media ${device.mobileL} {
        font-size: 0.6rem;
    }
`;

// LIST

export const ListInfo = styled(ShadowOrBorderBox)((props) => ({
    color: props.theme.mainColor,
    background: props.theme.secondColor,
    margin: `0.3em 4em 1em 0`,
    padding: '2em',
    borderRadius: '0.5em',
    width: 'calc(50% - 5em)',
    float: 'left',
    boxSizing: 'border-box',
    maxHeight: 'calc(100vh - 13rem)',
    overflowY: 'scroll',
}));

export const ListItem = styled(ShadowOrBorderBox)`
    cursor: pointer;
    margin-top: 0.3em;
    margin-bottom: 1.4em;
    margin-left: 0.3em;
    background-color: ${(props) => props.theme.secondColor};
    padding: 1rem;
    @media ${device.mobileL} {
        padding: 1vw;
    }
    @media ${device.laptop} {
        padding: 2vw;
    }

    border-radius: 0.5rem;
    color: ${(props) => props.theme.mainColor};

    display: flex;

    svg {
        font-size: 2.2em;
        margin-right: 0.5em;
    }

    h2 {
        font-weight: 600;
        font-size: 1.8em;
        margin: 0;
        max-width: 20em;
        overflow-wrap: break-word;
        line-height: 1;
        color: ${(props) => props.theme.mainColor};
    }
    p {
        font-weight: 400;
        font-style: italic;
        font-size: 0.8em;
        margin: 0.5em 0 0 0;
        max-width: 20em;
        overflow-wrap: break-word;
        line-height: 1;
        color: ${(props) => props.theme.mainColor};
    }
`;

export const Button = styled.button`
    background: ${(props) => props.theme.secondColor};
    color: ${(props) => props.theme.mainColor};
    font-weight: 600;
    font-style: italic;
    font-size: 1.6em;
    border: none;
    border-radius: 0.3em;
    padding: 0.4em 0.9em;
    margin: 0 0 1em 0;
    ${(props) => shadowBorderString(props)}
`;

export const ListCategoryButton = styled<any>(ShadowOrBorderBox)`
    background: ${(props) => (props.selected ? props.theme.mainColor : props.theme.secondColor)};
    color: ${(props) => (props.selected ? props.theme.secondColor : props.theme.mainColor)};
    position: relative;
    display: inline-block;
    height: 1.3em;
    padding: 0.8em 1em;
    margin: 0.7em;
    border-radius: 0.5em;
    cursor: pointer;
`;
